/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";
import { withTranslation } from "react-i18next";
import PropTypes from "prop-types";
import { DivBackgroundOpacity } from "@utils/extra-style";

const GeneralInfo = (props) => {
  const { data, column } = props;

  return (
    <DivBackgroundOpacity opacity={data.status === 2 ? "0.5" : "1"}>
      {column === "id" && <div>{"#" + data.id}</div>}
      {column === "name" && <div>{data.name}</div>}
      {column === "email" && <div>{data.email}</div>}
      {column === "company" && <div>{data.company}</div>}
      {column === "lastLogin" && <div>{data.lastLogin || "—"}</div>}
      {column === "createdAt" && <div>{data.createdAt || "—"}</div>}
    </DivBackgroundOpacity>
  );
};

GeneralInfo.propTypes = {
  t: PropTypes.func.isRequired,
  data: PropTypes.object.isRequired,
  column: PropTypes.string.isRequired,
};

export default withTranslation()(GeneralInfo);
